const loadingLabel = "Nalaganje";
const slSI = {
  loadingLabel
};
export {
  slSI as default,
  loadingLabel
};
